import CompaniesNewTemplate from '@/features/agent/companies/templates/CompaniesNewTemplate';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/agent/companies/new')({
  component: CompaniesNewTemplate,
});
